import numeral from "numeral";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { MONTHS } from "../../constants";
import { anggaran } from "../../utils/financeFormula";
import { dateIndo } from "../../utils/helper";

const DetailLabaRugi = () => {
  const location = useLocation();
  const history = useHistory();
  const d = localStorage.getItem(location.pathname);
  const data = d ? JSON.parse(d) : null;
  if (data === null) history.push("/approval");

  const parseStatus = (s) => {
    const status = [
      {},
      { className: "badge badge-warning", text: "Pending" },
      { className: "badge badge-success", text: "Approved" },
      { className: "badge badge-danger", text: "Rejected" },
    ];
    return <span className={status[s].className}>{status[s].text}</span>;
  };

  const tables1 = [
    { label: "Created By", value: data?.createdBy?.name ?? "-", type: "text" },
    { label: "Created At", value: data?.createdAt ? dateIndo(data?.createdAt) : "-", type: "text" },
    { label: "Updated By", value: data?.updatedBy?.name ?? "-", type: "text" },
    { label: "Updated At", value: data?.updatedAt ? dateIndo(data?.updatedAt) : "-", type: "text" },
    { label: "Approved By", value: data?.approvedBy?.name ?? "-", type: "text" },
    { label: "Approved At", value: data?.approvedAt ? dateIndo(data?.approvedAt) : "-", type: "text" },
    { label: "Rejected By", value: data?.rejectedBy?.name ?? "-", type: "text" },
    { label: "Rejected At", value: data?.rejectedAt ? dateIndo(data?.rejectedAt) : "-", type: "text" },
    { label: "Status", value: parseStatus(data.status) },
  ];

  const tables2 = [
    { label: "Pendapatan", value: data.pendapatan, type: "numeral" },
    { label: "Beban Pendapatan", value: data.bebanPendapatan, type: "numeral" },
    { label: <b>Laba Kotor</b>, value: anggaran.labaKotor(data), type: "numeral" },
    { label: "Beban Penjualan", value: data.bebanPenjualan, type: "numeral" },
    { label: "Beban Administrasi & Umum", value: data.bebanAdministrasi, type: "numeral" },
    { label: "Beban Operasional Lainnya", value: data.bebanOperasionalLainnya, type: "numeral" },
    { label: <b>Laba Usaha</b>, value: anggaran.labaUsaha(data), type: "numeral" },
    { label: "Pendapatan Lain-lain", value: data.pendapatanLain, type: "numeral" },
    { label: "Beban Lain-ain", value: data.bebanLain, type: "numeral" },
    { label: <b>EBITDA</b>, value: anggaran.ebitda(data), type: "numeral" },
    { label: "Beban Penyusutan", value: data.bebanPenyusutan, type: "numeral" },
    { label: <b>EBIT</b>, value: anggaran.ebit(data), type: "numeral" },
    { label: "Beban Bunga", value: data.bebanBunga, type: "numeral" },
    { label: <b>PBT</b>, value: anggaran.pbt(data), type: "numeral" },
    { label: "Beban Pajak", value: data.bebanPajak, type: "numeral" },
    { label: <b>Laba Bersih</b>, value: anggaran.labaBersih(data), type: "numeral" },
    { label: "Catatan", value: data.notes ?? "-", type: "text" },
  ];

  const tables3 = [
    { label: " PENDAPATAN USAHA ",value: data.pendapatan,type: "numeral" },
    { label: " Beban Material ",value: data.bebanMaterial,type: "numeral" },
    { label: " Beban Pegawai ",value: data.bebanPegawai,type: "numeral" },
    { label: " Factory Overhead ",value: data.factoryOverhead,type: "numeral" },
    { label: <b>Jumlah Beban Pokok Pendapatan</b>,value: anggaran.jumlahBebanPendapatan(data),type: "numeral" },
    { label: " Beban Administrasi dan Umum ",value: data.bebanAdministrasi,type: "numeral" },
    { label: " Beban Pendapatan dan Pemasaran ",value: data.bebanPendapatan,type: "numeral" },
    { label: " Beban CSR ",value: data.bebanCsr,type: "numeral" },
    { label: " Beban Penyusutan dan Amortisasi ",value: data.bebanPenyusutan,type: "numeral" },
    { label: <b>Jumlah Beban Usaha</b>,value: anggaran.jumlahBebanUsaha(data),type: "numeral" },
    { label: " Pendapatan (Beban) Penjualan Aktiva Tetap ",value: data.pbpAktivaTetap,type: "numeral" },
    { label: " Pendapatan (Beban) Penjualan Aktiva Non Produktif ",value: data.pbpAktivaNonproduktif,type: "numeral" },
    { label: " Pendapatan (Beban) Penjualan Aktiva Lain-lain ",value: data.pbpAktivaLainnya,type: "numeral" },
    { label: " Pendapatan (Beban) Penjualan Saham Penyertaan Langsung ",value: data.pbpSahamPenyertaan,type: "numeral" },
    { label: " Pendapatan Bunga ",value: data.pendapatanBunga,type: "numeral" },
    { label: " Beban Bunga ",value: data.bebanBunga,type: "numeral" },
    { label: " Pendapatan Lain-lain ",value: data.pendapatanLain,type: "numeral" },
    { label: " Beban Lain-lain ",value: data.bebanLain,type: "numeral" },
    { label: <b>Jumlah Pendapatan (Beban) Lain-lain</b>,value: anggaran.jumlahPendapatanLain(data),type: "numeral" },
    { label: <b> LABA SEBELUM PAJAK PENGHASILAN</b>,value: anggaran.labaSebelumPajakPenghasilan(data),type: "numeral" },
    { label: " Pajak Kini ",value: data.pajakKini,type: "numeral" },
    { label: " Pajak Tangguhan ",value: data.pajakTangguhan,type: "numeral" },
    { label: <b> LABA TAHUN BERJALAN SETELAH PAJAK</b>,value: anggaran.labaTahunBerjalanSetelahPajak(data),type: "numeral" },
    { label: " Pendapatan (Beban) Komprehensif Lain ",value: data.pbKomperhensifLain,type: "numeral" },
    { label: <b> LABA BERSIH KOMPREHENSIF TAHUN BERJALAN</b>,value: anggaran.labaBersih(data),type: "numeral" },
    { label: <b> EBIT</b>,value: anggaran.ebit(data),type: "numeral" },
    { label: <b> EBITDA</b>,value: anggaran.ebitda(data),type: "numeral" },
   
    { label: "Catatan", value: data.catatan ?? "-", type: "text" },
   
  ];

  return (
    <>
      <div className="card border-0 rounded-0">
        <div className="container py-4">
          <div className="row px-4">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mr-auto my-auto">
                Detail Laba Rugi - {MONTHS[data.month * 1 - 1]} {data.year}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-3">
        <div className="card container shadow-sm border-0 p-3">
          <div className="row">
            <div className="col-6">
              <table className="table table-striped">
                <tbody>
                  {tables3.map((table, i) => (
                    <tr key={i}>
                      <td width={300}>{table.label}</td>
                      <td>:&ensp; {table.type === "numeral" ? `Rp. ${numeral(table.value).format(0, 0)}` : table.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="col-6">
              <table className="table table-striped">
                <tbody>
                  {tables1.map((table, i) => (
                    <tr key={i}>
                      <td width={150}>{table.label}</td>
                      <td>:&ensp; {table.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-secondary" onClick={() => window.history.back()}>
                Kembali
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailLabaRugi;
